var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartlyCloudyDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "partly_x5F_cloudy_x5F_day",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFD02F",
    cx: 16.5,
    cy: 9.4999,
    r: 4.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M5.25,18.5c-1.5166,0-2.75-1.2334-2.75-2.7495 c0-1.1265,0.6777-2.127,1.7266-2.5483l0.3496-0.1406L4.5371,12.686C4.5137,12.4609,4.5,12.2324,4.5,12.0005 c0-3.584,2.916-6.5,6.5-6.5c2.9912,0,5.583,2.0288,6.3018,4.9331l0.0908,0.3677l0.3789,0.0117 c2.0908,0.0664,3.7285,1.7515,3.7285,3.8374c0,2.1226-1.7275,3.8496-3.8506,3.8496H5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D33",
    d: "M10.9998,6.0003c2.7609,0,5.1527,1.8724,5.8163,4.5533l0.182,0.7352l0.7571,0.024 c1.8194,0.0576,3.2446,1.5236,3.2446,3.3375c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2407,0-2.25-1.0093-2.25-2.2499 c0-0.921,0.5547-1.7391,1.413-2.0842l0.6991-0.281l-0.0774-0.7495c-0.0234-0.2263-0.0347-0.4341-0.0347-0.6353 C4.9998,8.6919,7.6914,6.0003,10.9998,6.0003 M10.9998,5.0003c-3.866,0-7,3.1331-7,7.0001c0,0.2499,0.015,0.4958,0.04,0.738 c-1.194,0.48-2.04,1.6449-2.04,3.012c0,1.794,1.455,3.2499,3.25,3.2499h12.4c2.403,0,4.35-1.9479,4.35-4.35 c0-2.3559-1.875-4.263-4.213-4.337C17.0318,7.2634,14.2838,5.0003,10.9998,5.0003L10.9998,5.0003z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudyDay);
export default __webpack_public_path__ + "static/media/partly_cloudy_day.a380af6b60dac049b33502c7d70d5d67.svg";
export { ForwardRef as ReactComponent };